import axios from 'axios'
import qs from 'qs';
var service = axios.create({
    baseURL: process.env.BASE_API,
    timeout: 50000
})
// 测试环境 　　　 https://test.tk.lanjiyin.com.cn
// 生产环境 　　　 https://tk.lanjiyin.com.cn
window.api = ''
window.userApi = ''
window.payApi = ''
window.imApi = ''
window.wxAppId = ''

if (location.hostname == 'm.lanjiyin.com.cn') {
    api = 'https://tk.lanjiyin.com.cn'
    // 预上线tk域名
    //api =  'https://devtk.lanjiyin.com.cn'
    userApi = "https://user.lanjiyin.com.cn"
    payApi = "https://pay.lanjiyin.com.cn"
    imApi = "https://im.lanjiyin.com.cn"
    window.wxAppId = "wx111e56c5ac493925"
} else if (location.hostname == 'mobile.lanjiyin.com.cn') {
    api = 'https://testtk.lanjiyin.com.cn'
    userApi = "https://testuser.lanjiyin.com.cn"
    payApi = "https://testpay.lanjiyin.com.cn"
    imApi = "https://testim.lanjiyin.com.cn"
    window.wxAppId = "wx111e56c5ac493925"
} else {
    if (true) {
        api = '/test'
        userApi = "/userApi"
        payApi = "/payApi"
        imApi = "/imApi"
    } else {
        api = '/api'
        userApi = "/userApi_api"
        payApi = "/payApi"
        imApi = "/imApi"
    }
}


//添加请求拦截器
service.interceptors.request.use(function (config) {
    //  *sign=签名，*version=版本号(可选，目前为当前版本)，
    // *from_device=来自安卓还是ios（可选，0：通用 1:Android 2:ios，目前为通用版），
    // *app_id=westernmd_1011
    // 'pharmic_0425'
    // 'pharmic'
    let data = {
        app_id: localStorage.getItem('app_id'),
        app_type: localStorage.getItem('app_type'),

        bundle_id: localStorage.getItem("bundle_id") || 'lanjiyin',
        big_user_id: localStorage.getItem('big_user_id'),
        is_h5: 1,
        is_merge: 1,
        time: 1,
        idfa: 111,

        // mobile_desc: "d57dc2200b5db4b6a3180bb01df2e11d",
        version: 738,
        from_device: 1,
    }
    let is_loading = false

    if (config.method == "get") {
        if (config.params == undefined) {
            config.params = {}
        }
        for (let key in config.params) {
            if (config.params[key] != undefined) {
                data[key] = config.params[key]
            }
        }
        config.params = data
        config.params.user_id = getUser_id(config.params.app_id)
        config.params.token = getToken(config.params.app_id)

        mob(config.params)
        is_loading = config.params.is_loading
        config.params.sign = getSign(config.params)
    }
    if (config.method == "post") {
        if (config.data == undefined) {
            config.data = {}
        }
        for (let key in config.data) {
            if (config.data[key] != undefined) {
                data[key] = config.data[key]
            }
        }
        config.data = data
        config.data.user_id = getUser_id(config.data.app_id)
        config.data.token = getToken(config.data.app_id)

        mob(config.data)
        is_loading = config.data.is_loading
        config.data.sign = getSign(config.data)
        config.data = qs.stringify(config.data)
    }
    if (/userApi/.test(config.url)) {
        config.url = userApi + config.url.replace(/userApi/, '');
    } else if (/payApi/.test(config.url)) {
        config.url = payApi + config.url.replace(/payApi/, '');
    } else if (/imApi/.test(config.url)) {
        config.url = imApi + config.url.replace(/imApi/, '');
    } else {
        config.url = api + config.url;
    }


    if (is_loading && vant) {
        vant.Toast.loading({
            duration: 0,
            message: "加载中",
            forbidClick: true,
        });
    }


    return config
}, function (error) {
    return Promise.reject(error)
})
//添加响应拦截器
service.interceptors.response.use(function (response) {
    if (response.headers.is_aes == 1) {
        response.data = JSON.parse(AesCbcDecrypt(response.data, 'lanjiyin20500423', 'lanjiyin20500423'))
    }
    // 将接口中的字符数字转为数字
    StringToNumber(response.data)
    if (response.config.method == "post") {
        vant.Toast.clear();
    } else {
        let data = response.config.params
        if (data && data.is_loading) {
            vant.Toast.clear();
        }
    }
    return response.data
}, function (error) {
    vant.Toast.clear();
    console.log('err' + error)
    return Promise.reject(error)
}
)
export default service


// WEBPACK FOOTER //
// ./src/http/index.js